<template>
  <div class="date">
    <el-row>
      <el-col :span="24">
        <div class="weeks">
          <!-- 日期 -->
          <ul class="days">
            <li  style="cursor: pointer; color: #fff;" @click="weekPre" class="prev-btn">
              <i class="fa fa-angle-left fa-icon" aria-hidden="true"></i>
              <span  class="hidden-sm-and-down" style="margin-left: 5px;">上一周</span>
            </li>
            <li style="cursor: pointer; color: #fff;" @click="pick(day, index)" v-for="(day, index) in days" :key="index"
              :class="{ selected: index == tabIndex }">
              <!--本月-->
              <span v-if="day.getMonth() + 1 != currentMonth" class="other-month item-wrapper">
                <p>{{ day | getWeekFormat }}</p>
                <span class="hidden-sm-and-down">{{ day | dateFormat }}</span>
              </span>
              <span v-else>
                <!--今天-->
                <span
                  v-if="day.getFullYear() == new Date().getFullYear() && day.getMonth() == new Date().getMonth() && day.getDate() == new Date().getDate()"
                  class="today-item">今天</span>
                <span class="item-wrapper" v-else>
                  <p>{{ day | getWeekFormat }}</p>
                  <span class="hidden-sm-and-down">{{ day | dateFormat }}</span>
                </span>
              </span>
            </li>
            <li style="cursor: pointer; color: #fff;" @click="weekNext" class="next-btn">
              <span class="hidden-sm-and-down" style="margin-right: 5px;">下一周</span>
              <i class="fa fa-angle-right fa-icon" aria-hidden="true"></i>
            </li>
          </ul>
        </div>
      </el-col>
    </el-row>
    <el-row>
     <div class="xiafnagbo">
      <div class="ciz">
        <div class="shiyasnh" v-if="(shoushu == 2)">
          <span class="shitime1">8:00</span>
          <span class="shitime2">模拟手术训练4-1</span>
        </div>
        <div class="shiyasnh" v-if="(shoushu == 1)">
          <span class="shitime1">9:00</span>
          <span class="shitime2">模拟手术训练3-5</span>
        </div>
      </div>
      <div class="ciz">
        <div class="shiyasnh" v-if="(shoushu == 2)">
          <span class="shitime1">10:00</span>
          <span class="shitime2">模拟手术训练3-13</span>
        </div>
        <div class="shiyasnh" v-if="(shoushu == 3)">
          <span class="shitime1">10:00</span>
          <span class="shitime2">模拟手术训练3-13</span>
        </div>
      </div>
      <div class="ciz">
        <div class="shiyasnh" v-if="(shoushu == 1)">
          <span class="shitime1">18:00</span>
          <span class="shitime2">模拟手术训练6-4</span>
        </div>
        <div class="shiyasnh" v-if="(shoushu == 1)">
          <span class="shitime1">14:00</span>
          <span class="shitime2">模拟手术训练2-1</span>
        </div>
      </div>
      <div class="ciz">
        <div class="shiyasnh" v-if="(shoushu == 2)">
          <span class="shitime1">13:00</span>
          <span class="shitime2">模拟手术训练8-1</span>
        </div>
        <div class="shiyasnh" v-if="(shoushu == 1)">
          <span class="shitime1">14:00</span>
          <span class="shitime2">模拟手术训练2-1</span>
        </div>
      </div>
      <div class="ciz">
        <div class="shiyasnh" v-if="(shoushu == 2)">
          <span class="shitime1" >17:00</span>
          <span class="shitime2">模拟手术训练2-1</span>
        </div>
        <div class="shiyasnh" v-if="(shoushu == 3)">
          <span class="shitime1" >17:00</span>
          <span class="shitime2">模拟手术训练2-1</span>
        </div>
        <div class="shiyasnh" v-if="(shoushu == 1)">
          <span class="shitime1">14:00</span>
          <span class="shitime2">模拟手术训练2-1</span>
        </div>
      </div>
      <div class="ciz">
        <div class="shiyasnh" v-if="(shoushu == 3)">
          <span class="shitime1">22:00</span>
          <span class="shitime2">模拟手术训练8-1</span>
        </div>
        <div class="shiyasnh" v-if="(shoushu == 2)">
          <span class="shitime1">23:00</span>
          <span class="shitime2">模拟手术训练4-1</span>
        </div>
        <div class="shiyasnh" v-if="(shoushu == 3)">
          <span class="shitime1">10:00</span>
          <span class="shitime2">模拟手术训练3-13</span>
        </div>
      </div>
     </div>
    </el-row>
  </div>
</template>
<script>
/* eslint-disable */
import moment from "moment";
export default {
  props: {
    dateValue: {
      type: String,
      default: moment(new Date()).format("YYYY-MM-DD")
    },
    timeValue: {
      type: String,
      default: "00:00"
    }
  },
  data() {
    return {
      shoushu:1,
      currentYear: 1970, // 年份
      currentMonth: 1, // 月份
      currentDay: 1, // 日期
      currentWeek: 1, // 星期
      days: [],
      value1: "",
      tabIndex: null,
      tabTimeIndex: 0,
      times: [
        "00:00~06:00",
        "06:00~12:00",
        "12:00~18:00",
        "18:00~24:00",
        "今日节目"
      ]
    };
  },
  filters: {
    dateFormat(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    getWeekFormat(date) {
      const weeksObj = {
        1: "周一",
        2: "周二",
        3: "周三",
        4: "周四",
        5: "周五",
        6: "周六",
        7: "周日"
      };
      let weekNumber = moment(date).isoWeekday();
      return weeksObj[weekNumber];
    }
  },

  mounted() {
    const index = _.findIndex(this.days, function (o) {
      // console.log('o: ', o.getDate());
      // console.log('new Date().getDate(): ', new Date().getDate());
      return o.getDate() === new Date().getDate();
    });
    console.log("index: ", index);
    this.tabIndex = index;
  },

  created() {
    this.initData(null);
  },

  methods: {
    formatDate(year, month, day) {
      const y = year;
      let m = month;
      if (m < 10) m = `0${m}`;
      let d = day;
      if (d < 10) d = `0${d}`;
      return `${y}-${m}-${d}`;
    },
    pickDate(date) {
      let newDate = moment(date).format("YYYY-MM-DD");
      this.$emit("dateValue", newDate);
    },
    initData(cur) {
      let date = "";
      if (cur) {
        date = new Date(cur);
      } else {
        date = new Date();
      }
      this.currentDay = date.getDate(); // 今日日期 几号
      this.currentYear = date.getFullYear(); // 当前年份
      this.currentMonth = date.getMonth() + 1; // 当前月份
      this.currentWeek = date.getDay(); // 1...6,0 // 星期几
      if (this.currentWeek === 0) {
        this.currentWeek = 7;
      }
      const str = this.formatDate(
        this.currentYear,
        this.currentMonth,
        this.currentDay
      ); // 今日日期 年-月-日
      this.days.length = 0;
      // 今天是周日，放在第一行第7个位置，前面6个 这里默认显示一周，如果需要显示一个月，则第二个循环为 i<= 35- this.currentWeek
      /* eslint-disabled */
      for (let i = this.currentWeek - 1; i >= 0; i -= 1) {
        const d = new Date(str);
        d.setDate(d.getDate() - i);
        // console.log(y:" + d.getDate())
        this.days.push(d);
      }
      for (let i = 1; i <= 7 - this.currentWeek; i += 1) {
        const d = new Date(str);
        d.setDate(d.getDate() + i);
        this.days.push(d);
      }
    },

    // 上个星期
    weekPre() {
      const d = this.days[0]; // 如果当期日期是7号或者小于7号
      d.setDate(d.getDate() - 7);
      this.initData(d);
      this.shoushu ++
      if(this.shoushu == 4){
        this.shoushu = 1
      }
    },

    // 下个星期
    weekNext() {
      const d = this.days[6]; // 如果当期日期是7号或者小于7号
      d.setDate(d.getDate() + 7);
      this.initData(d);
      this.shoushu ++
      if(this.shoushu == 4){
        this.shoushu = 1
      }
      console.log(this.shoushu)
    },

    // 上一個月 传入当前年份和月份
    pickPre(year, month) {
      const d = new Date(this.formatDate(year, month, 1));
      d.setDate(0);
      this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1));
    },

    // 下一個月 传入当前年份和月份
    pickNext(year, month) {
      const d = new Date(this.formatDate(year, month, 1));
      d.setDate(35);
      this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1));
    },

    // 当前选择日期
    pick(date, index) {
      let newDate = moment(date).format("YYYY-MM-DD");
      this.$emit("dateValue", newDate);
      // console.log("index: ", index);
      this.tabIndex = index;
      // alert(
      // this.formatDate(date.getFullYear(), date.getMonth() + 1, date.getDate())
      // );
    },
    pickTime(time, index) {
      // console.log('time: ', time);
      let timeArr = [];
      timeArr.push(_.head(_.split(time, "~")));
      console.log("timeArr: ", timeArr);
      this.$emit("timeValue", _.join(timeArr), "");
      // console.log("index: ", index);
      this.tabTimeIndex = index;
      // alert(
      // this.formatDate(date.getFullYear(), date.getMonth() + 1, date.getDate())
      // );
    }
  }
};
</script>
<style lang="less">
.date{
  width: 100%;
  height: 715px;
  background-color: #212129;
  .weeks{
    
  }
  .days{
    width: 1200px;
    display: flex;
    justify-content: space-between;
    margin:100px auto;
  }
  .xiafnagbo{
    width: 960px;
    height: 400px;
    margin: auto;
    background-color: rgb(247, 243, 243);
    display: flex;
    justify-content: space-between;
    .ciz{
      width: 159px;
      height: 100%;
      border: 1px solid #cacad3;
      .shiyasnh{
        width: 140px;
        height: 150px;
        background-color: #e8e8ee;
        margin:10px auto;
        position: relative;
        .shitime1{
          position: absolute;
          top: 10px;
          left: 20px;
        }
        .shitime2{
          position: absolute;
          top: 50px;
          left: 20px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Login/Questime.vue